import { useEffect } from "react";
import { Flame, CheckCircle2, PartyPopper } from "lucide-react";

export default function SignupSuccessPage() {
  useEffect(() => {
    // Redirect to home after a brief celebration
    const timer = setTimeout(() => {
      window.location.href = '/';
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="w-full max-w-md text-center">
        <div className="flex items-center justify-center gap-3 mb-8">
          <div className="p-3 bg-primary/20 rounded-xl">
            <Flame className="w-8 h-8 text-primary animate-pulse" />
          </div>
          <h1 className="text-3xl font-bold tracking-tight text-foreground">
            myFit<span className="text-primary">Beats</span>
          </h1>
        </div>

        <div className="bg-card border border-border/50 rounded-xl p-8">
          <div className="flex justify-center gap-2 mb-4">
            <CheckCircle2 className="w-12 h-12 text-green-500" />
            <PartyPopper className="w-12 h-12 text-primary" />
          </div>
          <h2 className="text-2xl font-bold mb-2">Welcome to myFitBeats!</h2>
          <p className="text-muted-foreground mb-4">
            Your account is all set up. Your 14-day free trial starts now!
          </p>
          <p className="text-sm text-muted-foreground">
            Redirecting you to your dashboard...
          </p>
        </div>
      </div>
    </div>
  );
}
